<template>
    <div>
        <span v-if="internalValue">{{ formatDate(internalValue) }}</span>
        <span v-if="!internalValue">-</span>
    </div>
</template>

<script>
    export default {
        name: 'Date',
        props: ['value','label','name','placeholder'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            formatDate: function(value){
                if( value ){
                    var d = new Date(value),
                        month = '' + (d.getMonth() + 1),
                        day = '' + d.getDate(),
                        year = d.getFullYear(),
                        hour = d.getHours(),
                        minute = d.getMinutes(),
                        second = d.getSeconds();

                    if (month.length < 2) month = '0' + month;
                    if (day.length < 2) day = '0' + day;

                    if (hour < 10) hour = '0' + hour;
                    if (minute < 10) minute = '0' + minute;
                    if (second < 10) second = '0' + second;



                    return [day, month, year].join('.') + ' ' + [hour, minute, second].join(':');
                }

                return value
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Date.vue